module.exports = __webpack_public_path__ + "static/media/logo.33f34671.png";